import { createApi } from '@reduxjs/toolkit/query/react';

import { ICreateMeetingFormValues, Meeting } from 'constants/types';

import { API_URLS, REQUEST_METHOD } from '../constants/global';
import { baseQueryForumFormData } from './baseQuery';

export const meetingManagement = createApi({
  reducerPath: 'meetingApi',
  baseQuery: baseQueryForumFormData,
  endpoints: (builder) => ({
    addMeeting: builder.mutation<void, ICreateMeetingFormValues>({
      query: (newMeeting) => ({
        url: API_URLS.MEETING,
        method: REQUEST_METHOD.POST,
        body: newMeeting,
      }),
    }),

    updateMeeting: builder.mutation<
      Meeting,
      { id: string; updatedMeeting: ICreateMeetingFormValues }
    >({
      query: ({ id, updatedMeeting }) => ({
        url: `${API_URLS.MEETING}/${id}`,
        method: REQUEST_METHOD.PUT,
        body: updatedMeeting,
      }),
    }),
  }),
});

export const { useAddMeetingMutation, useUpdateMeetingMutation } =
  meetingManagement;
